export default __webpack_public_path__ + "static/media/earnings.92b31eea.svg";